// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz1ml5{color:var(--_1xw92dq)}", ""]);
// Exports
module.exports = exports;
